<template>
  <div>
    <a-affix :offset-top="0">
      <a-layout-sider theme="light"
        style="flex: 0 0 180px;max-width:180px;min-width:180px;width:180px; margin:16px -4px 1% 0">
        <div class="menu-subs" v-for="menu in siderMenu" :key="menu.id">
          <div class="menu-title">
            <img :src="menu.icon" class="menu-icon">
            <h2>{{ menu.name }}</h2>
          </div>
          <div class="m_subs">
            <router-link v-for="item in menu.list" :key="item.path" :to="item.path" class="menu-link"
              :class="{ 'active': isActive(item.path, item.title) }">
              {{ item.title }}
            </router-link>
          </div>
        </div>
        <!-- <a-menu mode="inline" :defaultSelectedKeys="selectedMenu" :openKeys.sync="currentOpenKey">
            <template>
              <a-sub-menu v-for="menu in siderMenu" :key="menu.id">
                <span slot="title">
                  <img :src="menu.icon" width="20px" height="20px" style="margin-right:9px">
                  <span class="bold menu_title">{{ menu.name }}</span>
                </span>
                <a-menu-item v-for="item in menu.list" :key="item.path">
                  <router-link :to="item.path">{{ item.title }}</router-link>
                </a-menu-item>
              </a-sub-menu>
            </template>
      </a-menu> -->
      </a-layout-sider>
    </a-affix>
  </div>
</template>

<script>
export default {
  name: 'BasicMenu',
  data() {
    return {
      siderMenu: [],
      currentOpenKey: [],
      selectedMenu: [],
    }
  },
  created() {
    this.getSideMenu();
    this.getOpenKey();
  },

  methods: {
    isActive(path, title) {
      const currentPath = this.$route.path;
      const allPaths = ['depot/list', 'depot/history', 'depot/log'];


      if (title === '仓储囤货' && allPaths.some(p => currentPath.includes(p))) {
        return true;
      }
      if (title === '一键铺货' && currentPath === '/puhuoV2') {
        return true;
      }

      return currentPath === path;
    },
    getOpenKey() {
      var path = this.getRelationPath(this.$route.path);
      var menu = this.siderMenu;
      var keys = [];

      for (var i = 0; i < menu.length; i++) {
        for (var j = 0; j < menu[i].list.length; j++) {
          if (path == menu[i].list[j].path) {
            keys = [menu[i].id];
            break;
          }
        }
      }

      this.currentOpenKey = keys;
      this.selectedMenu = [path];
    },
    getRelationPath(path) {
      var relation = {
        '/recharge': '/finance/balance',
        '/point/list': '/finance/balance',
        '/point/rule': '/finance/balance',
        '/deposit/apply': '/finance/balance',
        '/depot/history': '/depot/list',
        '/depot/log': '/depot/list',
        '/refund/help/add': '/refund/help/list',
        '/refund/help/detail': '/refund/help/list',
        '/bind/email': '/safe',
        '/bind/mobile': '/safe',
        '/question': '/safe',
        '/password': '/safe',
        '/paypsd': '/safe',
        '/recharge/gold': '/finance/balance',
        '/order/recycle': '/order/list',
        '/eva/list': '/eva/list',
        '/eva/detail': '/eva/list',
        '/express/manage': '/express/send',
        '/express/freight': '/express/send',
        '/express/account': '/express/send',
        '/express/import': '/express/send',
        '/express/bill': '/express/send',
        '/express/logistics': '/express/send',
        '/refund/apply': '/order/list',
        '/refund/applySubmit': '/order/list',
        '/publish/top': '/publish/list',
        '/depot/order': '/depot/list',
        '/depot/over': '/depot/list',
        '/puhuo': '/puhuo',
        '/puhuoV2': '/puhuoV2',
        'puhuo/store': '/puhuo/store',

      };

      if (path.substring(0, 17) == '/complain/detail/') {
        path = '/complain/list';
      }

      if (path.substring(0, 14) == '/order/detail/') {
        path = '/order/list';
      }

      if (path.substring(0, 12) == '/depot/info/') {
        path = '/depot/list';
      }

      if (path.substring(0, 15) == '/refund/detail/') {
        path = '/refund/list';
      }

      if (relation[path] != null) {
        path = relation[path];
      }
      if (path.substring(0, 27) == '/distribution/order/detail') {
        path = '/distribution/order';
      }
      if (path.substring(0, 15) == '/refund/detail/') {
        path = '/refund/list';
      }
      return path;
    },
    getSideMenu() {
      this.siderMenu = [
        {
          id: 1,
          name: '交易管理',
          icon: require('@/assets/images/basic/trading.png'),
          list: [
            {
              path: '/order/list',
              title: '我的订单'
            },
            // {
            //   path: '/refund/list',
            //   title: '退款/售后'
            // },
            {
              path: '/refund/list',
              title: '退货退款'
            },
            {
              path: '/depot/list',
              title: '仓储囤货'
            },

            {
              path: '/eva/list',
              title: '评价管理'
            },
            // {
            //     path: '/tag/list',
            //     title: '自定义吊牌'
            // },
          ]
        },
        {
          id: 2,
          name: '网店同步',
          icon: require('@/assets/images/basic/store.png'),
          list: [{
            path: '/tools/manage',
            title: '网店管理'
          },
          {
            path: '/tools/match',
            title: '商品匹配'
          },
          {
            path: '/puhuoV2',
            title: '一键铺货'
          },
          // {
          //   path: '/update',
          //   title: '我的上传'
          // },
          {
            path: '/puhuo/store',
            title: '铺货店铺'
          },

          {
            path: '/taobao/order',
            title: '淘宝订单'
          },
          {
            path: '/dy/order',
            title: '抖店订单'
          },
          {
            path: '/pdd/order',
            title: '拼多多订单'
          },
          // {
          //   path: '/jd/order',
          //   title: '京东订单'
          // },
          {
            path: '/order/import',
            title: '手工订单',

          },
          ]
        },

        // {
        //   id: 2,
        //   name: '批量导入',
        //   icon: require('@/assets/images/basic/dh_daoru.png'),

        // },
        {
          id: 3,
          name: '收藏夹',
          icon: require('@/assets/images/basic/collectNav.png'),
          list: [
            {
              path: '/collect/goods',
              title: '收藏商品'
            },
            {
              path: '/focus/store',
              title: '关注商家'
            },
            {
              path: '/trace',
              title: '我的足迹'
            }
          ]
        },
        {
          id: 4,
          name: '分销管理',
          icon: require('@/assets/images/basic/distribution.png'),
          list: [
            {
              path: '/distribution/order',
              title: '分销订单'
            },
            {
              path: '/distribution/list',
              title: '分销资产'
            },
            {
              path: '/distribution/transpond',
              title: '我的转发'
            },
            {
              path: '/distribution/recycle',
              title: '回收站'
            },
          ]
        },
        {
          id: 5,
          name: '功能服务',
          icon: require('@/assets/images/basic/menu.png'),
          list: [
            // {
            //     path: '/publish/list',
            //     title: '我的发布'
            // },

            {
              path: '/data',
              title: '数据包'
            },
            {
              path: '/correct',
              title: '我的纠错'
            },
            // {
            //   path: '/intercept',
            //   title: '运费拦截'
            // },

            {
              path: '/complain/list',
              title: '投诉管理'
            },

            // {
            //   path: '/violation/list',
            //   title: '举报信息'
            // },
          ]
        },



        // {
        //   id: 3,
        //   name: '工具服务',
        //   icon: require('@/assets/images/basic/dh_gongju.png'),
        //   list: [
        //     // {
        //     //   path: '/refund/help/list',
        //     //   title: '帮忙退货'
        //     // },
        //
        //     {
        //       path: '/express/send',
        //       title: '快递服务'
        //     },


        //   ]
        // },


        // {
        //   id: 9,
        //   name: '售后管理',
        //   icon: require('@/assets/images/basic/refund_manage.png'),
        //   list: [

        //   ]
        // }

      ];
    },

  }
}
</script>

<style scoped> 
.menu_title {
  font-size: 16px;
  color: #333333;
}

.basic_layout {
  background: #f4f4f4;
}

.wh_fill {
  width: 100%;
  height: 100%;
}

.ant-layout-header {
  box-sizing: border-box;
  height: auto;
  line-height: unset;
  padding: 0;
  background: #f4f4f4;
}

.content_container {
  padding: 20px;
}

.menu-subs {
  width: 100%;
  text-align: left;
  padding: 0 0 23px 18px; 
  box-sizing: border-box;
}

.menu-subs:nth-of-type(1) {
  margin-top: 16px;
}

.m_subs {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.menu-subs>.menu-title{
  display: flex;
  align-items: center; 
}
 
.menu-subs a {
  display: block;
  /* height: 32px;  
     line-height: 32px;  
     padding: 10px 20px; */
  box-sizing: border-box;
  margin-top: 16px; 
}

.menu-subs>.menu-title > h2{
  margin-left: 6px;
  color: #000000; font-size: 16px;
  font-style: normal;
  font-weight: 600;
}

.menu-subs>.menu-title>.menu-icon {
  width: 16px;
  height: 16px; 
}

.menu-subs>a>span {
  display: inline-block;
  height: 32px;
} 

.menu-subs a {
  color: #666;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
  flex: 0 0 50%;
  overflow: hidden;
}

.menu-subs a.active {
  color: #fd5902;
  font-weight: 500;
}

.menu-subs a:hover {
  color: #fd5902;
  font-weight: 500;
}

.sub_menu {
  width: 145px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/basic/BasicMenu.vue